/** @jsx jsx */

import { ComponentProps } from 'react';

import { Tag } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import {
  APP_STATUSES_DISPLAY_NAME,
  VersionStatus,
} from 'app/developer-v3/constants';

type Props = {
  label: APP_STATUSES_DISPLAY_NAME | VersionStatus | string;
  size?: ComponentProps<typeof Tag>['size'];
  variant?: ComponentProps<typeof Tag>['variant'];
};

const defaultProps = {
  size: 'small' as const,
  variant: 'default' as const,
};

function StatusLabel({
  label,
  size = defaultProps.size,
  variant = defaultProps.variant,
}: Props) {
  return (
    <Tag size={size} variant={variant}>
      {label}
    </Tag>
  );
}

export default StatusLabel;
